import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  TRANSACTION_HISTORY: {
    path: `${baseRoutes.adminBaseRoutes}/transaction-history`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon-note-list" />
      </span>
    ),
  },
};

export default accessRoute;
